import React, { MouseEvent } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks/redux";
import { IPage, setActivePage } from "store/reducers/QuotesPageReducer";
import { setActivePageId } from "store/reducers/quotes";
import {
    PinnedTabItem,
    PinnedTabName,
    PinnedTabsContainer,
} from "./pinnedTabsListStyles";
import { useNavigate } from "react-router-dom";

const PinnedTabsList: React.FC = () => {
    const dispatch = useDispatch();
    const { selectedRobotId } = useAppSelector((state) => state.robots);
    const { pages, activePage } = useAppSelector((state) => state.quotesPage);
    const navigate = useNavigate();
    const pinnedPages = (pages ?? [])
        .filter((p: IPage) => p?.is_pinned)
        .sort((a: IPage, b: IPage) => a.id - b.id);

    if (!selectedRobotId || pinnedPages.length === 0) {
        return null;
    }

    const handleTabClick = (e: MouseEvent<HTMLDivElement>, id: number) => {

        const cookieKey = `activePageId_${selectedRobotId}`;
        Cookies.set(cookieKey, id.toString(), { expires: 30 });

        dispatch(setActivePageId(id.toString()));
        dispatch(setActivePage(id));
        navigate("/quotes");
    };

    return (
        <PinnedTabsContainer>
            {pinnedPages.map((page: IPage) => {
                const isActive = activePage?.id === page.id;
                return (
                    <PinnedTabItem
                        key={`pinned_${page.id}`}
                        $isActive={isActive}
                        onClick={(e) => handleTabClick(e, page.id)}
                        title={page.name}
                    >
                        <PinnedTabName>{page.name.slice(0, 6)}</PinnedTabName>
                    </PinnedTabItem>
                );
            })}
        </PinnedTabsContainer>
    );
};

export default PinnedTabsList;
